type SortField = "name" | "department" | "read";
type SortDirection = "asc" | "desc";

export function calcReadPercentage(
	readCount: number,
	totalRecipients: number
): number {
	if (totalRecipients === 0) return 0;
	return Math.round((readCount / totalRecipients) * 100);
}

export function sortUsers(
	users: AnnouncementAnalytics["users"],
	sortField: SortField,
	sortDirection: SortDirection
): AnnouncementAnalytics["users"] {
	return [...users].sort((a, b) => {
		const dir = sortDirection === "asc" ? 1 : -1;
		if (sortField === "name")
			return (
				dir *
				`${a.firstName} ${a.lastName}`.localeCompare(
					`${b.firstName} ${b.lastName}`
				)
			);
		if (sortField === "department")
			return dir * (a.department ?? "").localeCompare(b.department ?? "");
		if (sortField === "read") return dir * (Number(a.read) - Number(b.read));
		return 0;
	});
}
